import { PageWithActions } from "@endya-conformite/ui-kit";
import { PropsWithChildren, ReactNode } from "react";
import {
  ConnectedPageTemplate,
  ConnectedPageTemplateProps,
} from "./ConnectedPageTemplate";
import styles from "./PageWithTitleTemplate.module.scss";

type ControleQuinquennalTemplateProps<T> = {
  title: string;
  actions?: ReactNode;
} & PropsWithChildren &
  Pick<ConnectedPageTemplateProps<T>, "breadcrumb" | "maxWidth">;

export function PageWithTitleTemplate<T>({
  title,
  actions,
  breadcrumb,
  maxWidth,
  children,
}: ControleQuinquennalTemplateProps<T>) {
  return (
    <ConnectedPageTemplate breadcrumb={breadcrumb} maxWidth={maxWidth}>
      <PageWithActions actions={actions} fixedActions>
        <div className={styles.header}>
          <h1>{title}</h1>
          <div className={styles.content}>{children}</div>
        </div>
      </PageWithActions>
    </ConnectedPageTemplate>
  );
}
